import React, { Component } from "react";
import { mensajeExito } from "../../generico/MensajeSistemaToast";
import DataTable from "react-data-table-component";
import MensajeUsuario from "../../generico/MensajeUsuario";
import { ThemeConsumer } from "styled-components";
import AuthService from "../../../services/login/auth.service";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import MomentLocaleUtils, { formatDate } from "react-day-picker/moment";
import ActividadesEducacionService from "../../../services/pagos/ActividadesEducacionService";
import { trackPromise } from 'react-promise-tracker';
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faFilePdf} from "@fortawesome/free-solid-svg-icons";

export default class EducacionPaso4 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({});

  componentDidMount() {}

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      },
    ];
  }

  getDatosActividad() {
    var acti = this.props.actividad;
    var cabecera = this.props.cuentaDebito.cabecera;
    var cantidadEntradas = this.props.cantidadEntradas;
    var costoTotal;
    if(cabecera !== undefined){
      costoTotal = this.props.cantidadEntradas * cabecera.costo
    }

    var respuesta = [];
    if (cabecera !== undefined) {
      respuesta = [
        { concepto: "Nro. de actividad:", valor: acti[0].actividad },
        { concepto: "Nombre actividad:", valor: acti[0].descripcion },
        { concepto: "Fecha:", valor: cabecera.fecha },
        { concepto: "Hora:", valor: cabecera.hora },
        {
          concepto: "Ciudad:",
          valor: cabecera.ciudad.trim().length === 0 ? "-" : cabecera.ciudad,
        },
        {
          concepto: "Local:",
          valor: cabecera.lugar.trim().length === 0 ? "-" : cabecera.lugar,
        },
        {
          concepto: "Costo Unitario:",
          valor: formatoSeparadorMilesValue(cabecera.costo),
        },
        {
          concepto: "Cantidad:",
          valor: cantidadEntradas,
        },
        {
          concepto: "Costo Total:",
          valor: formatoSeparadorMilesValue(costoTotal),
        },
        { concepto: "Moneda:", valor: cabecera.moneda },
      ];
    }
    return respuesta;
  }

  descargar = async () => {
    var datosActividad = this.getDatosActividad();
    var nroActividad = datosActividad[0].valor;
    var nombreActividad = datosActividad[1].valor;
    var fecha = datosActividad[2].valor;
    var hora = datosActividad[3].valor;
    var ciudad = datosActividad[4].valor;
    var local = datosActividad[5].valor;
    var costo = datosActividad[8].valor;
    var moneda = datosActividad[9].valor;
    await trackPromise(
      ActividadesEducacionService.descagarComponente("Pago de Actividades", this.props.nroOperacion, AuthService.getSocio().numeroSocio.trim() + " - " + AuthService.getSocio().nombreCompleto, this.props.cuentaDebito.value + " - " + this.props.cuentaDebito.tipoDeCuenta, this.props.cuentaDebito.moneda, "Inscripción de la Actividad", nroActividad, nombreActividad, fecha, hora, ciudad, costo + " " + moneda, costo + " " + moneda,local)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

    this.setState({ listaFactura: true });
   // return listaFactura;
  };

  render() {
    if (this.props.currentStep === 4) {
      mensajeExito("El Pago de la Actividad se Realizó Correctamente");
    }
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Actividades
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Pago</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <p className="nro-operacion">
              Número de Operación: {this.props.nroOperacion}
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <h6 className="item-vef" style={{ margin: 0 }}>
              Socio: {AuthService.getSocio().numeroSocio.trim()} - 
              {AuthService.getSocio().nombreCompleto}
            </h6>
            <p className="item-vef" style={{ marginBottom: 0 }}>
              Cuenta de débito: {this.props.cuentaDebito.value}{" - "}{this.props.cuentaDebito.tipoDeCuenta}
            </p>
            <p className="item-vef">Moneda: {this.props.cuentaDebito.moneda} </p>   
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <label className="input-label-bold">
              Inscripción de la Actividad
            </label>
            <div className="table-responsive">
              <DataTable
                noHeader={true}
                columns={this.getColumn()}
                data={this.getDatosActividad()}
                dense={true}
                noDataComponent="No hay información la información"
                responsive={true}
                noTableHead={true}
              />
            </div>
          </div>
        </div>
        <br />
        {this.props.cuentaDebito.cabecera && (
          <div className="row justify-content-md-center">
            <div className="col-lg-8 col-md-10">
              <h6>
                Total Pagado:{" "}
                {formatoSeparadorMilesValue(
                  (this.props.cuentaDebito.cabecera.importe * this.props.cantidadEntradas)
                )}{" "}
                {this.props.cuentaDebito.cabecera.moneda}.
              </h6>
            </div>
          </div>
        )}
        <br />
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <MensajeUsuario
              tipo="INFO"
              titulo="Importante."
              mensaje="Este comprobante habilita a la persona inscripta a ingresar al recinto de nuestra 
                          institución y por razones de seguridad su presentación es de carácter obligatorio junto con 
                          su cédula de identidad."
            />
          </div>
        </div>

        <hr />
        <div className="row">
          <div className="col-lg-8 col-md-6"></div>
          <div className="col-lg-2 col-md-3 btn-consulta">
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            onClick={this.props.firstStep}
          ></button>

          <button
            className="btn btn-cu-quintary"
            onClick={(e) => {
              this.props.returnDataPaso4();
              this.nextStep.click();
            }}
          >
           <FontAwesomeIcon icon={faArrowLeft} />  Ir al Inicio
          </button>
          </div>
          <div className="col-lg-2 col-md-3">
          <button className="btn btn-cu-primary" onClick={this.descargar}><FontAwesomeIcon icon={faFilePdf} /> Descargar Comprobante</button>
          </div>
        </div>

      </div>
    );
  }
}
